// DRAWER MENU PRODUCT SLIDER -- START
var swiper = new Swiper('.drawer_products_slider', {
  scrollbar: {
    el: '.drawer__products .dp_swiper-scrollbar-horizontal',
  },
 slidesPerView: 2.5,
  spaceBetween: 12,
  navigation: {
    nextEl: '.drawer__products .next-arrow',
    prevEl: '.drawer__products .prev-arrow',
  },
});
// DRAWER MENU PRODUCT SLIDER -- END

//WHEN FILTER PAGE SCROLL DOWN AFTER TOTAL HEIGHT FILTER SCROLL TO ADD CLASS BODY JS START

jQuery(document).ready(function(){
  setTimeout(() => {
    if(jQuery('body').hasClass('sticky_filter')){
      var elementHeight = 0;
      if(jQuery('.collection-grid__wrapper .collection-filter').length>0){
        elementHeight = jQuery('.collection-grid__wrapper .collection-filter').offset().top
      }
      if(elementHeight!=0){
        $(window).scroll(function() {
          var height = $(window).scrollTop();
          if(height > elementHeight) {
            jQuery('body').addClass('filter_pass');
          }else{
            jQuery('body').removeClass('filter_pass');
          }
        });
      }
    }
  }, 1000);
});

//WHEN FILTER PAGE SCROLL DOWN AFTER TOTAL HEIGHT FILTER SCROLL TO ADD CLASS BODY JS END


jQuery(document).ready(function(){
  var checkRectImg = setInterval(function(){
    if (jQuery('body').hasClass('product_image_rect')) {
      if($('.pgi-rsquare .pro-collection-gallery').hasClass('slick-initialized')){
        $('.pgi-rsquare .pro-collection-gallery').slick('unslick');
      }
      
      $('.pgi-rsquare .pro-collection-gallery').slick({
        dots: true,
        infinite: true,
        speed: 200,
        cssEase: 'linear',
        arrows : false,
      });
      clearInterval(checkRectImg);
    }
  }, 500);
});

// Collection modal on + off -- START
/*
document.addEventListener("DOMContentLoaded", function () {
  const toggle = document.getElementById("collectionToggle");
  const grid = document.querySelector(".collection-grids");
  if(toggle!=null){
    toggle.addEventListener("change", function () {
      if (this.checked) {
        grid.classList.add("active-switch");
      } else {
        grid.classList.remove("active-switch");
      }
    });
  }
});
*/
if(jQuery(".collection-filter__item--modalswatch #collectionToggle").length>0){
  jQuery(document).on("change",".collection-filter__item--modalswatch #collectionToggle", function (e) {
     var checkobj = jQuery(this);
   //setTimeout(function(){
    var $toggle = $("#collectionToggle");
    var $grid = $(".collection-grids");
    var $wrapper = $(".modaltoggle-swatch");
   
    $grid.removeClass("active-switch");
    $wrapper.removeClass("active");
    
      if ($(checkobj).is(":checked")) {
        //console.log("checked",$grid);
        $grid.addClass("active-switch");
        $wrapper.addClass("active");
      } else {
        //console.log("else unchecked");
        $grid.removeClass("active-switch");
        $wrapper.removeClass("active");
      }
    //},200);
  });
}


// Collection modal on + off -- END


// JOIN INSTAGRAM -- START
$(".join_insta_slider").slick({
  slidesToShow: 6,
  slidesToScroll: 1,
  allowTouchMove: false,
  draggable: false,
  autoplay: true,
  autoplaySpeed: 0,
  arrow:false,
  dots:false,
  speed: 8000,
  pauseOnHover: false,
  infinite: true,
  cssEase: "linear",
  responsive: [
    {
      breakpoint: 1450,
      settings: {
        slidesToShow: 5,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
      },
    },
  ],
});
// JOIN INSTAGRAM -- END

/* MPS_092_HOME || Product Slider || START  */
let productSwipers = [];

function initProductSliders() {
  const isDesktop = window.innerWidth > 767;

  document.querySelectorAll(".productslider-grid").forEach((slider, index) => {
    const section = slider.closest(".mps-productslider");
    if (!section) return;

    const nextBtn = section.querySelector(".swiper-button-next");
    const prevBtn = section.querySelector(".swiper-button-prev");

    // INIT on desktop
    if (isDesktop && !productSwipers[index]) {
      productSwipers[index] = new Swiper(slider, {
        slidesPerView: 1,
        spaceBetween: 16,
        allowTouchMove: true,
        navigation: {
          nextEl: nextBtn,
          prevEl: prevBtn,
        },
        breakpoints: {
          768: { slidesPerView: 3 },
          992: { slidesPerView: 4 },
        },
      });
    }

    // DESTROY on mobile
    if (!isDesktop && productSwipers[index]) {
      productSwipers[index].destroy(true, true);
      productSwipers[index] = null;
    }
  });
}

document.addEventListener("DOMContentLoaded", initProductSliders);
window.addEventListener("resize", initProductSliders);


/*
var swiper = new Swiper(".productslider-grid", {
  slidesPerView: 1,
  spaceBetween: 16,
  allowTouchMove: true,
  navigation: {
    nextEl: ".mps-pslide-pagination .swiper-button-next",
    prevEl: ".mps-pslide-pagination .swiper-button-prev",
  },
  breakpoints: {
    320: {
      slidesPerView: 1.2,
    },
    479: {
      slidesPerView: 2.1,
    },
    768: {
      slidesPerView: 3,
    },
    992: {
      slidesPerView: 4,
    }
  }
});
*/

var swiper = new Swiper(".productslider-grid-two", {
  slidesPerView: 1,
  spaceBetween: 16,
  allowTouchMove: true,
  navigation: {
    nextEl: ".mps--pslide-pagination .swiper-button-next",
    prevEl: ".mps--pslide-pagination .swiper-button-prev",
  },
  breakpoints: {
    320: {
      slidesPerView: 1.2,
    },
    479: {
      slidesPerView: 2.1,
    },
    768: {
      slidesPerView: 3,
    },
    992: {
      slidesPerView: 4,
    }
  }
});

/* MPS_092_HOME || Product Slider || END  */


/* MPS_092_HOME || USP Bar || START  */
var swiper = new Swiper(".uspbar-grid", {
  slidesPerView: 1,
  spaceBetween: 0,
  breakpoints: {
    320: {
      slidesPerView: 1.1,
      spaceBetween: 10,
      centeredSlides: true,
      autoplay: {
        delay: 2500,
        disableOnInteraction: false,
      },
    },
    479: {
      slidesPerView: 1.3,
      spaceBetween: 10,
      centeredSlides: true,
      autoplay: {
        delay: 2500,
        disableOnInteraction: false,
      },
    },
    768: {
      slidesPerView: 2,
      spaceBetween: 0,
      autoplay: {
        delay: 2500,
        disableOnInteraction: false,
      },
    },
    992: {
      slidesPerView: 3,
      spaceBetween: 0,
    },
  },
});
/* MPS_092_HOME || USP Bar || END  */

// MPS_091_PDP TEXT MARQUEE -- START
$(".text_marquee_wrapper").slick({
  slidesToShow: 6,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 0,
  speed: 6000,
  pauseOnHover: false,
  arrows: false,
  dots: false,
  cssEase: "linear",
  variableWidth: true,
  responsive: [
    {
      breakpoint: 1240,
      settings: {
        slidesToShow: 5,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
      },
    },
  ],
});
// MPS_091_PDP TEXT MARQUEE -- END


// Cart Upsell Product START

var swiper = new Swiper(".main-upsells--container .custom--upsell-inner.swiper", {
  slidesPerView: 1,
  spaceBetween: 8,
  navigation: {
    nextEl: ".main-upsells--container .slider-nav-next",
    prevEl: ".main-upsells--container .slider-nav-prev",
  },
  pagination: {
    el: ".main-upsells--container .swiper-pagination",
    type: "progressbar",
  },
});

// Cart Upsell Product END

// PRODUCT DESCRIPTION READ MORE BUTTON JS START
document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".product_readmore_description").forEach(function (wrapper) {
    const fullHTML = wrapper.innerHTML;
    const limit = 130;

    function truncateHTMLWithReadMore(html, limit) {
      let count = 0;
      const container = document.createElement("div");
      container.innerHTML = html;
      let lastTextNode = null;

      function walk(node) {
        if (count >= limit) {
          node.remove();
          return;
        }

        if (node.nodeType === Node.TEXT_NODE) {
          if (count + node.nodeValue.length > limit) {
            node.nodeValue = node.nodeValue.substring(0, limit - count);
            count = limit;
          } else {
            count += node.nodeValue.length;
          }
          lastTextNode = node;
        } else if (node.nodeType === Node.ELEMENT_NODE) {
          Array.from(node.childNodes).forEach(walk);
        }
      }

      Array.from(container.childNodes).forEach(walk);

      if (lastTextNode) {
        lastTextNode.nodeValue += "...";
        const readMore = document.createElement("span");
        readMore.className = "toggle-readmore";
        readMore.innerHTML = "<strong> Read More</strong>";
        lastTextNode.after(readMore);
      }

      return container.innerHTML;
    }

    const truncatedHTML = truncateHTMLWithReadMore(fullHTML, limit);
    wrapper.innerHTML = truncatedHTML;

    wrapper.addEventListener("click", function (e) {
      if (!e.target.closest(".toggle-readmore")) return;

      const toggle = e.target.closest(".toggle-readmore");

      if (toggle.textContent.includes("Read More")) {
        wrapper.innerHTML =
          fullHTML +
          '<span class="toggle-readmore"><strong> Read Less</strong></span>';
      } else {
        wrapper.innerHTML = truncatedHTML;
      }
    });
  });
});
// PRODUCT DESCRIPTION READ MORE BUTTON JS END

// BRAND FEATURES VIDEO JS START
document.addEventListener('DOMContentLoaded', function () {
  const videoBlocks = document.querySelectorAll('.brand_feature_video');

  videoBlocks.forEach((item) => {
    const media = item.querySelector('video');
    const trigger = item.querySelector('.bf_video_btn');

    trigger.addEventListener('click', () => {
      const isActive = item.classList.contains('playing');

      if (isActive) {
        media.pause();
        item.classList.remove('playing');
      } else {
        // Stop all other videos
        videoBlocks.forEach((block) => {
          const vid = block.querySelector('video');
          if (vid) {
            vid.pause();
            block.classList.remove('playing');
          }
        });

        media.play();
        item.classList.add('playing');
      }
    });
  });
});
// BRAND FEATURES VIDEO JS END